import { render, staticRenderFns } from "./GeographicalDistributionForm.vue?vue&type=template&id=6e21171c&"
import script from "./GeographicalDistributionForm.vue?vue&type=script&lang=js&"
export * from "./GeographicalDistributionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports